<template>
  <div class="page form_page js_show">
    <div class="weui-form">
      <div class="weui-form__text-area">
        <h2 class="weui-form__title">业务员注册</h2>
        <div class="weui-form__desc">业务员信息注册完成后，由佰药汇运营审核，审核完成可进行门店建设</div>
      </div>
      <div class="weui-form__control-area">
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">姓名</label></div>
              <div class="weui-cell__bd">
                <input v-model="formSet.salesmanName" prop="salesmanName" class="weui-input" placeholder="请输入姓名">
              </div>
            </div>

            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">手机号</label></div>
              <div class="weui-cell__bd">
                <input v-model="formSet.salesmanPhone" class="weui-input" prop="salesmanPhone" placeholder="请输入手机号">
              </div>
            </div>

            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">公司</label></div>
              <div class="weui-cell__bd">
                <input v-model="formSet.salesmanCompany" class="weui-input" prop="salesmanCompany" placeholder="请输入公司">
              </div>
            </div>

            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">部门</label></div>
              <div class="weui-cell__bd">
                <input v-model="formSet.salesmanDept" class="weui-input" prop="salesmanDept" placeholder="请输入部门">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="weui-form__opr-area">
        <a class="weui-btn weui-btn_primary" href="javascript:" id="showTooltips" @click="handleSubmit">确定</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formSet: {
        id:'',
        salesmanName: '',
        salesmanPhone: '',
        salesmanCompany: '',
        salesmanDept: '',
        userFlag: 'salesman'
      },
      workerRules: {
        salesmanName: [
          {required: true, trigger: 'blur', message: '请输入您的姓名!'}
        ],
        salesmanDept: [
          {required: true, message: '请输入您的部门!', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    handleSubmit () {
      this.$axios({
        method: 'post',
        url: '/v1/wSalesman/save',
        data: this.formSet
      }).then((response) => {
        console.log('保存成功', response)
        if (response.data.code === 200) {
          let user = {id:response.data.data.id,username:response.data.data.salesmanName,userPhone:response.data.data.salesmanPhone,userFlag:'salesman'}
          this.$storage.saveStorage("user", user)
          this.$router.push({path: 'deptMan'})
        }
      }).catch((error) => {
        console.log('保存失败', '保存失败')
      })
    },
    getWorkInfo(){
      this.$axios({
        method: 'get',
        url: '/v1/wSalesman/info?id='+this.formSet.id
      }).then((response) => {
        if (response.data.code === 200) {
          this.formSet.data = response.data.data
        }
      }).catch((error) => {
        console.log('获取失败', '获取失败')
      })
    }
  },

  mounted () {
    // 如果当前已登录且为“我是业务员”直接跳转
    let user = this.$storage.fetchStorage("user")
    if (user !== null && user !== '') {
      this.$router.push({path: 'deptMan'})
    }
  },
  components: {

  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/Register/workerRegister.vue